export default __webpack_public_path__ + "static/media/9.e8040060.jpg";